import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/core"
import {
  weddingPartyMember,
  weddingPartyContent,
  contentLeft,
  weddingPartyMemberImage,
} from "../weddingPartyMember"

const imageWrapper = css`
  position: relative;
  width: 350px;
  top: 0px;

  @media screen and (min-width: 500px) {
    top: -40px;
  }

  @media screen and (min-width: 680px) {
    position: absolute;
    top: 0;
    right: -80px;
  }

  @media screen and (min-width: 860px) {
    width: 466px;
  }
`

const Erica = props => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "erica.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 466) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div css={weddingPartyMember}>
      <div css={[weddingPartyMemberImage, imageWrapper]}>
        <Img
          fluid={data.file.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
          {...props}
        />
      </div>
      <div css={[weddingPartyContent, contentLeft]}>
        <div>
          <h2>Erica Laba</h2>
          <p>
            What began as frenemies in the workplace, has grown into a
            sisterhood bound by questionable outfits, wonderous hikes, and a few
            stick and poke tattoos.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Erica
